// Simple reducer to replace state in original FormBuilder class component

import { FormTemplateType } from '@atom/types/form';

interface State {
  isDrawerOpen: boolean;
  selectedPage: number;
  formTemplate: FormTemplateType;
  pageInEditMode: any;
  selectedSchema?: string;
  pageName: string;
}

const initialFormTemplate = {
  id: '',
  name: '',
  createdDate: 0,
  createdBy: '',
  pages: [],
};

export const INIT_FORM_STATE: State = {
  isDrawerOpen: true,
  selectedPage: 0,
  pageInEditMode: null,
  pageName: '',
  selectedSchema: '',
  formTemplate: initialFormTemplate,
};

export const formBuilderStateReducer = (state: State, action) => {
  switch (action.type) {
    case 'UPDATE_STATE':
      return { ...state, ...action.data };
    default: {
      return state;
    }
  }
};
